/**
 * Socket.io client (singleton), come su gestionale-gls.
 *
 * Il backend mette il socket nelle stanze dello studio e dell'utente: gli
 * eventi `<dominio>:changed` diventano invalidazioni di React Query (vedi
 * hooks/useRealtimeSync.js). Il token si rilegge a ogni (ri)connessione.
 */
import { io as ioClient } from "socket.io-client";
import { API_URL } from "../config/app";
import { TOKEN_KEY } from "./storageKeys";

let socket = null;

const getToken = () => localStorage.getItem(TOKEN_KEY) || null;

export const getSocket = () => socket;
export const isConnected = () => Boolean(socket && socket.connected);

export function connectSocket() {
  if (!getToken()) return null;
  if (socket) {
    if (!socket.connected) socket.connect();
    return socket;
  }
  socket = ioClient(API_URL, {
    auth: (cb) => cb({ token: getToken() }),
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1500,
    reconnectionDelayMax: 15000,
  });
  socket.on("connect_error", (err) => {
    if (process.env.NODE_ENV !== "production") console.warn("[socket] connect_error:", err.message);
    if (["TOKEN_EXPIRED", "TOKEN_STALE", "INVALID_TOKEN"].includes(err?.message)) {
      import("./api")
        .then(({ forceTokenRefresh, getTokenExpiryMs }) => {
          if (err.message === "INVALID_TOKEN") {
            const expMs = getTokenExpiryMs();
            if (!expMs || expMs > Date.now()) return undefined;
          }
          return forceTokenRefresh();
        })
        .catch(() => {});
    }
  });
  return socket;
}

export function disconnectSocket() {
  if (!socket) return;
  try {
    socket.removeAllListeners();
    socket.disconnect();
  } catch (_) {
    /* ignore */
  }
  socket = null;
}

export function refreshSocketAuth() {
  if (!socket) return connectSocket();
  if (!getToken()) return disconnectSocket();
  if (socket.connected) socket.disconnect();
  socket.connect();
  return socket;
}
